import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectIsOnboardingContext } from '../../store/navigation/navigation.selectors'
import { isEqual } from '../../utils/lang'
import useComputePaddingGetter from './map.padding.utils'
import { MAP_FROM_APP_ACTION_PADDING } from './map.utils'
import { useCallbackWithMapContext, useMapContext } from './MapContext'

const useMapPaddingHandler = () => {
  const { interact } = useMapContext()
  const getPadding = useComputePaddingGetter()

  const isOnboardingContext = useSelector(selectIsOnboardingContext)

  const setPadding = useCallbackWithMapContext(
    map => {
      const padding = getPadding()
      if (!isEqual(map.getPadding(), padding)) {
        const animate = !isOnboardingContext
        interact({ padding, animate }, { fromAppAction: MAP_FROM_APP_ACTION_PADDING })
      }
    },
    [getPadding, interact, isOnboardingContext]
  )

  useEffect(() => {
    setPadding()
  }, [setPadding])
}

export default useMapPaddingHandler
